<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <h3>@all 2025 ipta Graduation Exhibition</h3>
          <p>國立清華大學藝術學院學士班第四屆畢業展</p>
        </div>
        <div class="footer-links">
          <h4>Quick Links</h4>
          <router-link to="/">Home</router-link>
          <router-link to="/concept">Concept</router-link>
          <router-link to="/introduction">Artworks</router-link>
          <router-link to="/artists">Artists</router-link>
          <router-link to="/visit">Visit</router-link>
          <router-link to="/game">Game</router-link>
        </div>
        <div class="footer-contact">
          <h4>More Info</h4>
          <p>Exhibition Address: <a href="https://maps.app.goo.gl/VwMnLRewri9uMcCbA" target="_blank">100台北市中正區八德路一段1號</a></p>
          <p>Instagram: <a href="https://www.instagram.com/all.ipta/?igsh=MTJqZnZyMXU0bTNhdA%3D%3D&utm_source=qr#" target="_blank">@all.ipta</a></p>
          <p>Facebook: <a href="https://www.facebook.com/atall.ipta?mibextid=wwXIfr&rdid=vVwVlGwnOmQpj1YD&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14EkZoFoRux%2F%3Fmibextid%3DwwXIfr#" target="_blank">國立清華大學藝術學院學士班第四屆畢業展 at all</a></p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; {{ new Date().getFullYear() }} @all 2025 ipta Graduation Exhibition. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background-color: #004D6B;
  color: #fff;
  padding: 50px 0 20px;
  margin-top: 50px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 30px;
}

.footer-logo h3 {
  font-size: 24px;
  margin-bottom: 10px;
}

.footer-links {
  display: flex;
  flex-direction: column;
}

.footer-links a {
  color: #ddd;
  margin-bottom: 10px;
}

.footer-links a:hover {
  color: rgba(240, 131, 30);
}

.footer-contact p {
  margin-bottom: 10px;
}

.footer-contact p a {
  color: #ddd;
  text-decoration: underline;
}

.footer-contact p a:hover {
  color: rgba(240, 131, 30);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;
  font-size: 14px;
}
</style>
